import { createStyles } from "@mantine/emotion";

export const useStylesModalCreate = createStyles((theme) => ({
  modal: {
    ".mantine-Modal-content": {
      maxWidth: theme.spacing.modalCreate.contentMaxWidth,
    },

    h2: {
      fontSize: theme.spacing.modalCreate.titleFontSize,
      marginBottom: theme.spacing.modalCreate.titleMarginBottom,
      marginTop: theme.spacing.modalCreate.titleMarginTop,
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
      fontFamily: theme.headings.fontFamily.primary,
      fontWeight: "bold",
    },
  },

  modalText: {
    width: "100%",
    textAlign: "left",
    fontSize: theme.spacing.modalCreate.textFontSize.default,
    marginTop: theme.spacing.modalCreate.textMarginTop,
    fontFamily: theme.headings.fontFamily.light,

    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      fontSize: theme.spacing.modalCreate.textFontSize.desktop,
    },

    b: {
      fontWeight: "bolder",
    },
  },

  modalTextCollectionKey: {
    display: "block",
  },

  modalConfirmationTitle: {
    fontSize: theme.spacing.modalCreate.titleFontSize,
    marginTop: theme.spacing.modalCreate.confirmationTitleMarginTop,
    marginBottom: theme.spacing.modalCreate.confirmationTitleMarginBottom,
    textAlign: "center",
  },

  portfolioPreview: {
    backgroundColor: theme.customBackgrounds.verifyStampZone,
    borderRadius: theme.spacing.modalCreate.titleMarginTop,
    padding: theme.spacing.modalCreate.textMarginTop,
    fontFamily: theme.headings.fontFamily.light,
    margin: 0,
    overflowY: "auto",
    maxHeight: theme.spacing.modalCreate.previewMaxHeight,
  },

  portfolioNormalizedNote: {
    marginTop: theme.spacing.xs,
    fontSize: theme.spacing.md,
    color: theme.customColors.dimmed,
    fontFamily: theme.headings.fontFamily.light,
  },

  portfolioMetricsTitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing.xs,
  },

  portfolioMetricsValue: {
    fontSize: theme.spacing.md,
    fontFamily: theme.headings.fontFamily.light,
  },

  portfolioMetricsLabel: {
    fontWeight: "bold",
  },

  portfolioWarning: {
    fontSize: theme.spacing.md,
    color: theme.customColors.orange,
    marginBottom: theme.spacing.xs,
    fontFamily: theme.headings.fontFamily.light,
  },

  portfolioCid: {
    fontFamily: theme.headings.fontFamily.light,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  portfolioSection: {
    marginTop: theme.spacing.md,
  },
}));
